import type { SVGProps } from 'react';
export const ZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M3.37 12.25a.6.6 0 0 1 .65.13l3.6 3.6A.6.6 0 0 1 7.2 17H3.6a.6.6 0 0 1-.6-.6v-3.6a.6.6 0 0 1 .37-.55"
      clipRule="evenodd"
    />
    <path fillRule="evenodd" d="M8.82 11.18a.6.6 0 0 1 0 .84L6.25 14.6l-.85-.85 2.58-2.57a.6.6 0 0 1 .84 0" clipRule="evenodd" />
    <path
      fillRule="evenodd"
      d="M16.63 7.75a.6.6 0 0 1-.65-.13l-3.6-3.6A.6.6 0 0 1 12.8 3h3.6c.33 0 .6.27.6.6v3.6a.6.6 0 0 1-.37.55"
      clipRule="evenodd"
    />
    <path fillRule="evenodd" d="M11.18 8.82a.6.6 0 0 1 0-.84l2.57-2.58.43.42.42.43-2.58 2.57a.6.6 0 0 1-.84 0" clipRule="evenodd" />
  </svg>
);
